import axios from 'axios'

const THEME_CONFIG_KEY = 'site_theme_config'
let themeConfigCache = null

const ThemeManager = {

    async loadTheme() {
        try {
            console.log('🎨 正在加载主题配置...')
            const response = await axios.get('/api/site-configs/map')
            themeConfigCache = response.data
            this.applyTheme(themeConfigCache)
            localStorage.setItem(THEME_CONFIG_KEY, JSON.stringify(themeConfigCache))
            console.log('✅ 主题配置加载成功:', themeConfigCache)
            return themeConfigCache
        } catch (error) {
            console.error('❌ 加载主题失败:', error)
            const cached = localStorage.getItem(THEME_CONFIG_KEY)
            if (cached) {
                themeConfigCache = JSON.parse(cached)
                this.applyTheme(themeConfigCache)
                return themeConfigCache
            }
            return this.getDefaultTheme()
        }
    },

    applyTheme(config) {
        if (!config) return
        const root = document.documentElement
        const colorMappings = {
            'primary_color': '--primary-color',
            'secondary_color': '--secondary-color',
            'accent_color': '--accent-color',
            'bg_primary': '--bg-primary',
            'bg_secondary': '--bg-secondary',
            'text_primary': '--text-primary',
            'text_secondary': '--text-secondary'
        }
        Object.entries(colorMappings).forEach(([configKey, cssVar]) => {
            if (config[configKey]) {
                root.style.setProperty(cssVar, config[configKey])
            }
        })
        if (config.site_name_zh) {
            document.title = config.site_name_zh
        }
    },

    getDefaultTheme() {
        const defaults = {
            primary_color: '#1a56db',
            secondary_color: '#1e40af',
            accent_color: '#d97706',
            bg_primary: '#ffffff',
            bg_secondary: '#f8fafc',
            text_primary: '#1e293b',
            text_secondary: '#64748b',
            site_name_zh: '产品展示台',
            site_name_en: 'Product Showcase',
            site_description_zh: '为您推荐最优质的产品系列',
            site_description_en: 'Recommending the best product series for you',
            contact_email: 'contact@example.com',
            contact_phone: '+86 123-4567-8900',
            contact_address: '',
            about_content_zh: '我们是一家专注于产品展示与推广的科技公司，致力于为客户提供最优质的产品展示解决方案。',
            about_content_en: 'We are a technology company focused on product display and promotion, dedicated to providing customers with the best product display solutions.',
            about_image: '[]',
            copyright_text_zh: '© 2024 产品展示台 版权所有',
            copyright_text_en: '© 2024 Product Showcase. All rights reserved.'
        }
        this.applyTheme(defaults)
        return defaults
    },

    getConfig(key) {
        if (!themeConfigCache) {
            const cached = localStorage.getItem(THEME_CONFIG_KEY)
            if (cached) {
                try { themeConfigCache = JSON.parse(cached) } catch (e) {}
            }
        }
        if (!themeConfigCache) { themeConfigCache = this.getDefaultTheme() }
        return themeConfigCache[key] || null
    },

    getSiteName(locale) {
        return locale === 'zh' ?
            (this.getConfig('site_name_zh') || '产品展示台') :
            (this.getConfig('site_name_en') || 'Product Showcase')
    },

    getSiteDescription(locale) {
        return locale === 'zh' ?
            (this.getConfig('site_description_zh') || '为您推荐最优质的产品系列') :
            (this.getConfig('site_description_en') || 'Recommending the best product series for you')
    },

    getContactInfo() {
        return {
            email: this.getConfig('contact_email') || 'contact@example.com',
            phone: this.getConfig('contact_phone') || '+86 123-4567-8900',
            address: this.getConfig('contact_address') || ''
        }
    },
    getAboutContent(locale) {
        const imagesStr = this.getConfig('about_image') || '[]'
        let images = []
        try {
            images = JSON.parse(imagesStr)
            if (!Array.isArray(images)) images = []
        } catch (e) {
            // 兼容旧版本：如果只存了一个URL，转为数组
            images = imagesStr ? [imagesStr] : []
        }
        return {
            content: locale === 'zh' ?
                (this.getConfig('about_content_zh') || '') :
                (this.getConfig('about_content_en') || ''),
            images: images
        }
    },
    getSocialLinks() {
        return {
            wechatQr: this.getConfig('wechat_qrcode'),
            weibo: this.getConfig('weibo_url'),
            twitter: this.getConfig('twitter_url'),
            facebook: this.getConfig('facebook_url')
        }
    },

    getCopyrightText(locale) {
        return locale === 'zh' ?
            (this.getConfig('copyright_text_zh') || '© 2024 产品展示台 版权所有') :
            (this.getConfig('copyright_text_en') || '© 2024 Product Showcase. All rights reserved.')
    },

    getIcpNumber() {
        return this.getConfig('icp_number') || ''
    },

    clearCache() {
        themeConfigCache = null
        localStorage.removeItem(THEME_CONFIG_KEY)
    },

    async refreshTheme() {
        this.clearCache()
        return await this.loadTheme()
    }
}

export default ThemeManager